// ═══ 세금계산서 발행/조회 페이지 ═══
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CompanyListPanel from './CompanyListPanel';

function TaxInvoicePage({ showToast, user }) {
  var isAdmin = user && (user.role === '관리자' || user.role === 'admin');
  var isDocAgency = user && user.role === 'doc_agency';
  var showCompanyFilter = isAdmin || isDocAgency;
  var [filterCompanyId, setFilterCompanyId] = useState(
    (isAdmin || isDocAgency) && user ? (user.activeCompanyId || user.companyId || '') : ''
  );
  var [tab, setTab] = useState('issue');
  var [company, setCompany] = useState({});
  var [list, setList] = useState([]);
  var [listLoading, setListLoading] = useState(false);
  var [issuing, setIssuing] = useState(false);

  var [receivedList, setReceivedList] = useState([]);
  var [receivedLoading, setReceivedLoading] = useState(false);
  var [corpCheckResult, setCorpCheckResult] = useState(null);
  var [corpChecking, setCorpChecking] = useState(false);

  // 공급받는자
  var [rcvBizNo, setRcvBizNo] = useState('');
  var [rcvName, setRcvName] = useState('');
  var [rcvCeo, setRcvCeo] = useState('');
  var [rcvAddr, setRcvAddr] = useState('');
  var [rcvBizType, setRcvBizType] = useState('');
  var [rcvBizItem, setRcvBizItem] = useState('');
  var [rcvEmail, setRcvEmail] = useState('');

  // 품목
  var [items, setItems] = useState([{ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }]);

  // 발행 옵션
  var [purposeType, setPurposeType] = useState('\uC601\uC218');
  var [taxType, setTaxType] = useState('\uACFC\uC138');

  // 공급자 정보 (editable)
  var [supBizNo, setSupBizNo] = useState('');
  var [supName, setSupName] = useState('');
  var [supCeo, setSupCeo] = useState('');
  var [supAddr, setSupAddr] = useState('');
  var [supBizType, setSupBizType] = useState('');
  var [supBizItem, setSupBizItem] = useState('');
  var [supTel, setSupTel] = useState('');
  var [supEmail, setSupEmail] = useState('');

  // 업체 정보 로드
  useEffect(function () {
    var cid = filterCompanyId || (user && (user.activeCompanyId || user.companyId)) || '';
    if (!cid) return;
    authFetch(API + '/settings/company?companyId=' + cid).then(function (r) { return r.json(); }).then(function (d) {
      setCompany(d || {});
      setSupBizNo((d && d.bizNo) || '');
      setSupName((d && (d.nameKr || d.companyName)) || '');
      setSupCeo((d && d.ceo) || '');
      setSupAddr((d && (d.addrKr || d.addr)) || '');
      setSupBizType((d && d.bizType) || '');
      setSupBizItem((d && d.bizItem) || '');
      setSupTel((d && d.tel) || '');
      setSupEmail((d && d.email) || '');
    }).catch(function () { });
  }, [filterCompanyId, user]);

  // 목록 로드
  var loadList = function () {
    setListLoading(true);
    var today = new Date();
    var startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1).toISOString().slice(0, 10).replace(/-/g, '');
    var endDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    authFetch(API + '/tax-invoice/list?startDate=' + startDate + '&endDate=' + endDate).then(function (r) { return r.json(); }).then(function (d) {
      setList(d.success ? (d.invoices || []) : []);
      setListLoading(false);
    }).catch(function () { setListLoading(false); });
  };

  useEffect(function () { if (tab === 'list') loadList(); if (tab === 'received') loadReceived(); }, [tab]);

  var loadReceived = function () {
    setReceivedLoading(true);
    var today = new Date();
    var startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1).toISOString().slice(0, 10).replace(/-/g, '');
    var endDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    authFetch(API + '/tax-invoice/received/list?startDate=' + startDate + '&endDate=' + endDate).then(function (r) { return r.json(); }).then(function (d) {
      setReceivedList(d.success ? (d.invoices || []) : []);
      setReceivedLoading(false);
    }).catch(function () { setReceivedLoading(false); });
  };

  var checkCorp = function () {
    var num = rcvBizNo.replace(/-/g, '');
    if (!num || num.length !== 10) { showToast('\uC0AC\uC5C5\uC790\uBC88\uD638 10\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694', 'err'); return; }
    setCorpChecking(true); setCorpCheckResult(null);
    authFetch(API + '/tax-invoice/check-corp?corpNum=' + num).then(function (r) { return r.json(); }).then(function (d) {
      setCorpChecking(false);
      if (d.success) {
        setCorpCheckResult(d);
        if (d.corpName && !rcvName) setRcvName(d.corpName);
      } else { setCorpCheckResult({ status: d.error || '\uC870\uD68C \uC2E4\uD328' }); }
    }).catch(function () { setCorpChecking(false); setCorpCheckResult({ status: '\uC870\uD68C \uC2E4\uD328' }); });
  };

  // 품목 금액 계산
  var updateItem = function (idx, field, val) {
    setItems(function (prev) {
      var next = prev.slice();
      next[idx] = Object.assign({}, next[idx], { [field]: val });
      if (field === 'qty' || field === 'unitCost') {
        var q = parseInt(next[idx].qty) || 0;
        var u = parseInt(next[idx].unitCost) || 0;
        var sc = q * u;
        next[idx].supplyCost = String(sc);
        next[idx].tax = String(Math.round(sc * 0.1));
      }
      return next;
    });
  };

  var addItem = function () {
    setItems(function (prev) { return prev.concat({ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }); });
  };

  var removeItem = function (idx) {
    setItems(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); });
  };

  // 합계
  var totalSupply = items.reduce(function (s, it) { return s + (parseInt(it.supplyCost) || 0); }, 0);
  var totalTax = items.reduce(function (s, it) { return s + (parseInt(it.tax) || 0); }, 0);
  var totalAmount = totalSupply + totalTax;

  // 발행
  var handleIssue = function () {
    if (!supBizNo) { showToast('\uACF5\uAE09\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC5C5\uCCB4 \uC124\uC815\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.', 'err'); return; }
    if (!rcvBizNo) { showToast('\uACF5\uAE09\uBC1B\uB294\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.', 'err'); return; }
    if (items.length === 0 || !items[0].itemName) { showToast('\uD488\uBAA9\uC744 1\uAC1C \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.', 'err'); return; }

    setIssuing(true);
    var bizNoClean = (supBizNo || '').replace(/-/g, '');
    var body = {
      writeDate: new Date().toISOString().slice(0, 10).replace(/-/g, ''),
      purposeType: purposeType,
      taxType: taxType,
      supplyCostTotal: totalSupply,
      taxTotal: totalTax,
      totalAmount: totalAmount,
      invoicerCorpNum: bizNoClean,
      invoicerCorpName: supName,
      invoicerCEOName: supCeo,
      invoicerAddr: supAddr,
      invoiceeCorpNum: rcvBizNo.replace(/-/g, ''),
      invoiceeCorpName: rcvName,
      invoiceeCEOName: rcvCeo,
      invoiceeAddr: rcvAddr,
      invoiceeType: '\uC0AC\uC5C5\uC790',
      dtlList: items.map(function (it, i) {
        return { serialNum: i + 1, itemName: it.itemName, unitCost: parseInt(it.unitCost) || 0, qty: parseInt(it.qty) || 1, supplyCost: parseInt(it.supplyCost) || 0, tax: parseInt(it.tax) || 0 };
      })
    };

    authFetch(API + '/tax-invoice/issue', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      setIssuing(false);
      if (d.success) {
        showToast('\u2705 \uC138\uAE08\uACC4\uC0B0\uC11C \uBC1C\uD589 \uC644\uB8CC');
        setRcvBizNo(''); setRcvName(''); setRcvCeo(''); setRcvAddr(''); setRcvBizType(''); setRcvBizItem(''); setRcvEmail('');
        setItems([{ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }]);
      } else {
        showToast(d.error || '\uBC1C\uD589 \uC2E4\uD328', 'err');
      }
    }).catch(function (e) { setIssuing(false); showToast('\uBC1C\uD589 \uC2E4\uD328: ' + (e.message || ''), 'err'); });
  };

  // PDF
  var openPdf = function (itemKey) {
    authFetch(API + '/tax-invoice/' + itemKey + '/pdf').then(function (r) { return r.json(); }).then(function (d) {
      if (d.success && d.url) window.open(d.url, '_blank');
      else showToast('PDF URL \uC870\uD68C \uC2E4\uD328', 'err');
    }).catch(function () { showToast('PDF \uC624\uB958', 'err'); });
  };

  var ls = { display: 'block', fontSize: 11, fontWeight: 600, color: '#64748b', marginBottom: 4, marginTop: 10 };
  var is = { width: '100%', padding: '7px 10px', border: '1px solid #d0d5dd', borderRadius: 6, fontSize: 12, outline: 'none', background: '#fff' };

  return (
    <div style={{ display: 'flex', gap: 16, height: 'calc(100vh - 120px)' }}>
      {showCompanyFilter && <CompanyListPanel user={user} context="tax" month="" selectedCompanyId={filterCompanyId} onSelect={function (id) { setFilterCompanyId(id); }} />}

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {/* 탭 */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <button onClick={function () { setTab('issue'); }} style={{ padding: '10px 24px', borderRadius: 8, border: tab === 'issue' ? '2px solid #2563eb' : '1px solid #d0d5dd', background: tab === 'issue' ? '#eff6ff' : '#fff', color: tab === 'issue' ? '#2563eb' : '#475569', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>{'\uD83D\uDCDD \uBC1C\uD589'}</button>
          <button onClick={function () { setTab('list'); }} style={{ padding: '10px 24px', borderRadius: 8, border: tab === 'list' ? '2px solid #2563eb' : '1px solid #d0d5dd', background: tab === 'list' ? '#eff6ff' : '#fff', color: tab === 'list' ? '#2563eb' : '#475569', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>{'\uD83D\uDCCB \uB9E4\uCD9C'}</button>
          <button onClick={function () { setTab('received'); }} style={{ padding: '10px 24px', borderRadius: 8, border: tab === 'received' ? '2px solid #16a34a' : '1px solid #d0d5dd', background: tab === 'received' ? '#f0fdf4' : '#fff', color: tab === 'received' ? '#16a34a' : '#475569', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>{'\uD83D\uDCE5 \uB9E4\uC785'}</button>
        </div>

        {tab === 'issue' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {/* 공급자 */}
            <div className="card" style={{ padding: 16 }}>
              <h3 style={{ fontSize: 14, marginBottom: 12, color: '#1B3A5C' }}>{'\uACF5\uAE09\uC790 \uC815\uBCF4'}</h3>
              <label style={ls}>{'\uC0AC\uC5C5\uC790\uBC88\uD638'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizNo} onChange={function(e){setSupBizNo(e.target.value)}} />
              <label style={ls}>{'\uC0C1\uD638'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supName} onChange={function(e){setSupName(e.target.value)}} />
              <label style={ls}>{'\uB300\uD45C\uC790'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supCeo} onChange={function(e){setSupCeo(e.target.value)}} />
              <label style={ls}>{'\uC8FC\uC18C'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supAddr} onChange={function(e){setSupAddr(e.target.value)}} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC5C5\uD0DC'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizType} onChange={function(e){setSupBizType(e.target.value)}} /></div>
                <div><label style={ls}>{'\uC885\uBAA9'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizItem} onChange={function(e){setSupBizItem(e.target.value)}} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC804\uD654\uBC88\uD638'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supTel} onChange={function(e){setSupTel(e.target.value)}} /></div>
                <div><label style={ls}>{'\uC774\uBA54\uC77C'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supEmail} onChange={function(e){setSupEmail(e.target.value)}} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 }}>
                <div>
                  <label style={ls}>{'\uBC1C\uD589 \uC720\uD615'}</label>
                  <select style={is} value={purposeType} onChange={function (e) { setPurposeType(e.target.value); }}>
                    <option value={'\uC601\uC218'}>{'\uC601\uC218'}</option>
                    <option value={'\uCCAD\uAD6C'}>{'\uCCAD\uAD6C'}</option>
                  </select>
                </div>
                <div>
                  <label style={ls}>{'\uACFC\uC138 \uC720\uD615'}</label>
                  <select style={is} value={taxType} onChange={function (e) { setTaxType(e.target.value); }}>
                    <option value={'\uACFC\uC138'}>{'\uACFC\uC138'}</option>
                    <option value={'\uC601\uC138'}>{'\uC601\uC138'}</option>
                    <option value={'\uBA74\uC138'}>{'\uBA74\uC138'}</option>
                  </select>
                </div>
              </div>
            </div>

            {/* 공급받는자 */}
            <div className="card" style={{ padding: 16 }}>
              <h3 style={{ fontSize: 14, marginBottom: 12, color: '#1B3A5C' }}>{'\uACF5\uAE09\uBC1B\uB294\uC790 \uC815\uBCF4'}</h3>
              <label style={ls}>{'\uC0AC\uC5C5\uC790\uBC88\uD638'}</label>
              <div style={{ display: 'flex', gap: 6 }}>
                <input style={Object.assign({}, is, { flex: 1 })} value={rcvBizNo} onChange={function (e) { setRcvBizNo(e.target.value); setCorpCheckResult(null); }} placeholder="000-00-00000" />
                <button onClick={checkCorp} disabled={corpChecking} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d0d5dd', background: corpChecking ? '#f1f5f9' : '#fff', fontSize: 11, fontWeight: 700, cursor: corpChecking ? 'default' : 'pointer', whiteSpace: 'nowrap' }}>{corpChecking ? '...' : '\uC870\uD68C'}</button>
              </div>
              {corpCheckResult && <div style={{ marginTop: 4, fontSize: 11, fontWeight: 700, color: corpCheckResult.status === '\uC815\uC0C1' ? '#16a34a' : corpCheckResult.status === '\uD734\uC5C5' ? '#d97706' : corpCheckResult.status === '\uD3D0\uC5C5' ? '#dc2626' : '#94a3b8' }}>
                {corpCheckResult.status}{corpCheckResult.corpName ? ' — ' + corpCheckResult.corpName : ''}
              </div>}
              <label style={ls}>{'\uC0C1\uD638'}</label>
              <input style={is} value={rcvName} onChange={function (e) { setRcvName(e.target.value); }} />
              <label style={ls}>{'\uB300\uD45C\uC790'}</label>
              <input style={is} value={rcvCeo} onChange={function (e) { setRcvCeo(e.target.value); }} />
              <label style={ls}>{'\uC8FC\uC18C'}</label>
              <input style={is} value={rcvAddr} onChange={function (e) { setRcvAddr(e.target.value); }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC5C5\uD0DC'}</label><input style={is} value={rcvBizType} onChange={function (e) { setRcvBizType(e.target.value); }} /></div>
                <div><label style={ls}>{'\uC885\uBAA9'}</label><input style={is} value={rcvBizItem} onChange={function (e) { setRcvBizItem(e.target.value); }} /></div>
              </div>
              <label style={ls}>{'\uC774\uBA54\uC77C'}</label>
              <input style={is} value={rcvEmail} onChange={function (e) { setRcvEmail(e.target.value); }} placeholder="email@example.com" type="email" />
            </div>

            {/* 품목 */}
            <div className="card" style={{ padding: 16, gridColumn: '1 / -1' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uD488\uBAA9 (' + items.length + '\uAC74)'}</h3>
                <button onClick={addItem} style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #2563eb', background: '#eff6ff', color: '#2563eb', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>+ {'\uD488\uBAA9 \uCD94\uAC00'}</button>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['\uC77C\uC790', '\uD488\uBAA9\uBA85', '\uADDC\uACA9', '\uC218\uB7C9', '\uB2E8\uAC00', '\uACF5\uAE09\uAC00\uC561', '\uC138\uC561', ''].map(function (h, i) {
                      return <th key={i} style={{ padding: '8px 6px', borderBottom: '2px solid #e2e8f0', textAlign: 'left', fontWeight: 700, color: '#475569' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {items.map(function (it, idx) {
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: 4 }}><input style={{ width: 80, padding: '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: 11 }} value={it.date} onChange={function (e) { updateItem(idx, 'date', e.target.value); }} placeholder="YYYYMMDD" /></td>
                        <td style={{ padding: 4 }}><input style={{ width: '100%', padding: '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: 11 }} value={it.itemName} onChange={function (e) { updateItem(idx, 'itemName', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={{ width: 60, padding: '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: 11 }} value={it.spec} onChange={function (e) { updateItem(idx, 'spec', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={{ width: 40, padding: '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: 11, textAlign: 'right' }} type="number" value={it.qty} onChange={function (e) { updateItem(idx, 'qty', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={{ width: 80, padding: '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: 11, textAlign: 'right' }} type="number" value={it.unitCost} onChange={function (e) { updateItem(idx, 'unitCost', e.target.value); }} /></td>
                        <td style={{ padding: 4, textAlign: 'right', fontWeight: 600, fontSize: 11 }}>{(parseInt(it.supplyCost) || 0).toLocaleString()}</td>
                        <td style={{ padding: 4, textAlign: 'right', fontSize: 11 }}>{(parseInt(it.tax) || 0).toLocaleString()}</td>
                        <td style={{ padding: 4 }}>{items.length > 1 && <button onClick={function () { removeItem(idx); }} style={{ background: '#fee2e2', border: 'none', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 10, color: '#dc2626' }}>{'\uC0AD\uC81C'}</button>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/* 합계 */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 20 }}>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{'\uACF5\uAE09\uAC00\uC561'}: <b>{totalSupply.toLocaleString()}</b></div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{'\uC138\uC561'}: <b>{totalTax.toLocaleString()}</b></div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: '#1B3A5C', marginTop: 4 }}>{'\uD569\uACC4'}: {totalAmount.toLocaleString()}{'\uC6D0'}</div>
                </div>
              </div>

              {/* 발행 버튼 */}
              <button onClick={handleIssue} disabled={issuing} style={{ width: '100%', marginTop: 16, padding: '14px', background: issuing ? '#94a3b8' : '#2563eb', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: issuing ? 'default' : 'pointer' }}>
                {issuing ? '\uBC1C\uD589 \uC911...' : '\uD83D\uDCDD \uC138\uAE08\uACC4\uC0B0\uC11C \uBC1C\uD589'}
              </button>
            </div>
          </div>
        )}

        {tab === 'list' && (
          <div className="card" style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uBC1C\uD589 \uBAA9\uB85D (\uCD5C\uADFC 3\uAC1C\uC6D4)'}</h3>
              <button onClick={loadList} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
            </div>
            {listLoading ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>
            ) : list.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uBC1C\uD589\uB41C \uC138\uAE08\uACC4\uC0B0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['\uBC1C\uD589\uC77C', '\uAD00\uB9AC\uBC88\uD638', '\uACF5\uAE09\uBC1B\uB294\uC790', '\uD569\uACC4\uAE08\uC561', '\uC0C1\uD0DC', 'PDF'].map(function (h, i) {
                      return <th key={i} style={{ padding: '10px 8px', borderBottom: '2px solid #e2e8f0', textAlign: 'left', fontWeight: 700, color: '#475569' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {list.map(function (inv, idx) {
                    var stColor = inv.stateCode >= 300 ? '#16a34a' : inv.stateCode >= 200 ? '#d97706' : '#94a3b8';
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 8px' }}>{inv.writeDate || '-'}</td>
                        <td style={{ padding: '10px 8px', fontFamily: 'monospace', fontSize: 11 }}>{inv.invoicerMgtKey || inv.itemKey || '-'}</td>
                        <td style={{ padding: '10px 8px' }}>{inv.invoiceeCorpName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontWeight: 600 }}>{(parseInt(inv.totalAmount) || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: stColor === '#16a34a' ? '#dcfce7' : stColor === '#d97706' ? '#fef3c7' : '#f1f5f9', color: stColor }}>
                            {inv.stateCode >= 300 ? '\uBC1C\uD589\uC644\uB8CC' : inv.stateCode >= 200 ? '\uC804\uC1A1\uC911' : '\uB300\uAE30'}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px' }}>
                          <button onClick={function () { openPdf(inv.itemKey); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #ef4444', background: '#fff', color: '#ef4444', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>PDF</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}

        {tab === 'received' && (
          <div className="card" style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 14, margin: 0, color: '#16a34a' }}>{'\uD83D\uDCE5 \uB9E4\uC785 \uC138\uAE08\uACC4\uC0B0\uC11C (\uCD5C\uADFC 3\uAC1C\uC6D4)'}</h3>
              <button onClick={loadReceived} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
            </div>
            {receivedLoading ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>
            ) : receivedList.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uC218\uCDE8\uD55C \uC138\uAE08\uACC4\uC0B0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f0fdf4' }}>
                    {['\uBC1C\uD589\uC77C', '\uACF5\uAE09\uC790', '\uD488\uBAA9', '\uD569\uACC4\uAE08\uC561', '\uC0C1\uD0DC', 'PDF'].map(function (h, i) {
                      return <th key={i} style={{ padding: '10px 8px', borderBottom: '2px solid #bbf7d0', textAlign: 'left', fontWeight: 700, color: '#166534' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {receivedList.map(function (inv, idx) {
                    var stColor = inv.stateCode >= 300 ? '#16a34a' : inv.stateCode >= 200 ? '#d97706' : '#94a3b8';
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 8px' }}>{inv.writeDate || '-'}</td>
                        <td style={{ padding: '10px 8px' }}>{inv.invoicerCorpName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontSize: 11 }}>{(inv.detailList && inv.detailList[0] && inv.detailList[0].itemName) || inv.itemName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontWeight: 600 }}>{(parseInt(inv.totalAmount) || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: stColor === '#16a34a' ? '#dcfce7' : stColor === '#d97706' ? '#fef3c7' : '#f1f5f9', color: stColor }}>
                            {inv.stateCode >= 300 ? '\uBC1C\uD589\uC644\uB8CC' : inv.stateCode >= 200 ? '\uC804\uC1A1\uC911' : '\uB300\uAE30'}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px' }}>
                          <button onClick={function () { openPdf(inv.itemKey); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #16a34a', background: '#fff', color: '#16a34a', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>PDF</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default TaxInvoicePage;
